import { Dashboard } from '../components/dashboard/Dashboard';

export function DashboardPage() {
  return <Dashboard />;
}